import { FunctionComponent } from "react";


export interface ICreditInfoLineProps {
    title: string;
    content: string;
}


const CreditInfoLine: FunctionComponent<ICreditInfoLineProps> = ({title, content}) => (
    <>
        <h4 className="text-primary text-2xl mt-12 mb-4 font-[700]">
            {title}
        </h4>
        <p>{content}</p>
    </>
);


export default CreditInfoLine;


